import { useLanguage, useSeo } from '../i18n/LanguageContext';
import { IMAGES } from '../data/images';
import { Eyebrow, MaskedLines, Reveal, SectionHead } from '../components/bits';
import PageHero from '../components/PageHero';
import FinalCTA from '../components/FinalCTA';

export default function About() {
  const { t } = useLanguage();
  useSeo('about');
  const a = t.aboutPage;

  return (
    <main>
      <PageHero eyebrow={a.eyebrow} lines={[a.line1, a.line2]} img={IMAGES.aboutHero} alt={a.alt} />

      <section className="noise-bg bg-cream py-20 md:py-32" data-testid="about-story">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 sm:px-12 lg:grid-cols-12 lg:px-20">
          <div className="lg:col-span-3">
            <Eyebrow>DELUXE</Eyebrow>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <p className="font-display text-2xl font-bold leading-snug tracking-tight text-ink sm:text-3xl">
                {a.p1}
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 max-w-2xl text-base leading-relaxed text-neutral-600 sm:text-lg">{a.p2}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 md:py-32" data-testid="why-deluxe">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
          <SectionHead eyebrow={a.whyEyebrow} lines={[a.whyHeading]} />
          <div className="mt-16 grid grid-cols-1 gap-10 border-t border-ink/15 pt-12 md:grid-cols-3">
            {a.principles.map((p, i) => (
              <Reveal key={p.n} delay={i * 0.1}>
                <span className="font-mono text-sm font-semibold tracking-[0.3em] text-[#C6A15B]">{p.n}</span>
                <h3 className="mt-4 font-display text-xl font-extrabold uppercase tracking-tight text-ink">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-600">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="noise-bg bg-cream py-20 md:py-28" data-testid="team-placeholder">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
          <Reveal>
            <div className="border border-dashed border-forest/30 p-10 sm:p-14">
              <Eyebrow>{t.aboutHome.eyebrow}</Eyebrow>
              <MaskedLines
                as="h2"
                lines={[a.teamTitle]}
                inView
                delay={0.1}
                className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-ink sm:text-3xl"
              />
              <p className="mt-5 max-w-xl text-base leading-relaxed text-neutral-600">{a.teamBody}</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-ink py-20 md:py-32" data-testid="service-area">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
          <Eyebrow dark>{t.area.eyebrow}</Eyebrow>
          <MaskedLines
            as="h2"
            lines={[t.area.line1, t.area.line2]}
            inView
            delay={0.1}
            className="mt-6 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl"
          />
          <Reveal delay={0.2}>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">{t.area.body}</p>
          </Reveal>
        </div>
      </section>

      <FinalCTA />
    </main>
  );
}
